import { getStorageItem, setStorageItem, removeStorageItem, STORAGE_KEYS } from '@/utils/storage';

const state = {
  corpId: getStorageItem(STORAGE_KEYS.CORP_ID),
  agentId: getStorageItem(STORAGE_KEYS.AGENT_ID)
}
const mutations = {
    setCorpId(state, corpId) {
      state.corpId = corpId;
      setStorageItem(STORAGE_KEYS.CORP_ID, corpId);
    },
    setAgentId(state, agentId) {
      state.agentId = agentId;
      setStorageItem(STORAGE_KEYS.AGENT_ID, agentId);
    },
    clearCorpData(state) {
      state.corpId = null;
      state.agentId = null;
      removeStorageItem(STORAGE_KEYS.CORP_ID);
      removeStorageItem(STORAGE_KEYS.AGENT_ID);
    }
}
const actions = {
    setCorpId({commit}, corpId) {
      commit('setCorpId', corpId);
    },
    setAgentId({commit}, agentId) {
      commit('setAgentId', agentId);
    },
    // 同时设置企业ID和应用ID
    setCorpInfo({commit}, {corpId, agentId}) {
      commit('setCorpId', corpId);
      commit('setAgentId', agentId);
    },
    // 从存储中恢复企业信息
    restoreCorpState({commit}) {
      const corpId = getStorageItem(STORAGE_KEYS.CORP_ID);
      const agentId = getStorageItem(STORAGE_KEYS.AGENT_ID);
      
      if (corpId) {
        commit('setCorpId', corpId);
      }
      if (agentId) {
        commit('setAgentId', agentId);
      }
    },
    // 清除所有企业数据
    clearAllCorpData({commit}) {
      commit('clearCorpData');
    }
}
const getters = {
    corpId(state) {
      return state.corpId;
    },
    agentId(state) {
      return state.agentId;
    },
    hasCorpInfo(state) {
      return !!(state.corpId && state.agentId);
    },
    corpInfo(state) {
      return {
        corpId: state.corpId,
        agentId: state.agentId
      };
    }
}
export default {
  state,
  mutations,
  actions,
  getters
}